import { useState, useEffect } from 'react';

interface GoogleMapsCallback {
  __googleMapsCallback?: () => void;
}

export function useGoogleMaps() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // If Google Maps is already loaded, set loaded state
    if (window.google?.maps) {
      setIsLoaded(true);
      return;
    }

    const callbackName = '__googleMapsCallback';

    // Create a global callback function
    (window as unknown as GoogleMapsCallback)[callbackName] = () => {
      setIsLoaded(true);
      console.log('Google Maps script loaded successfully');
    };

    // Create script element
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCOICn5qqHZBzfWYIKQWwnsts9iZ0MoYXs&callback=${callbackName}`;
    script.async = true;
    script.defer = true;

    // Handle script error
    script.onerror = () => {
      console.error('Failed to load Google Maps script');
      setError('Failed to load Google Maps');
    };

    // Add script to document
    document.head.appendChild(script);

    // Cleanup
    return () => {
      (window as unknown as GoogleMapsCallback)[callbackName] = undefined;
      const scriptElement = document.querySelector(`script[src*="${script.src}"]`);
      if (scriptElement) {
        document.head.removeChild(scriptElement);
      }
    };
  }, []);

  return { isLoaded, error };
} 